import { combineReducers } from 'redux';

// import test from './test.js'
import contentCheck from './content-check.js';
import resize from './resize';
import auth from './auth';

export default combineReducers({
  // test,
  contentCheck,
  resize,
  auth
});
